"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var en = {
    home: "Home",
    productCenter: "Product Center",
    about: "About",
    aboutContent: "The Taiwan R & D team develops \"Internet of Things and Intelligent Security\" related products and technology development and product design in the cloud, and can create exclusive customized products according to customer needs, and has good manufacturing and sales channels.",
    contact: "Contact",
    lightPorduct: "Light Porduct",
    plugPorduct: "Plug Porduct",
    extensionCordPorduct: "Extension Cord Porduct",
    securityPorduct: "Security Porduct",
    address: "16F.-6, No. 872, Zhongzheng Rd., Zhonghe Dist., New Taipei City 235, Taiwan (R.O.C.)",
    validationValue: "The field is not filled.",
    validationMail: "Mail format error",
    userName: "Name *",
    subject: "Subject *",
    body: "Problem *",
    mailResult: "Thank you for your letter, your question will be dealt with as soon as possible.",
    send: "Send",
};
exports.default = en;
